"use client";

import { Dispatch, SetStateAction, createContext, useContext, useState } from "react";

type SidebarContextData = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const SidebarContext = createContext({} as SidebarContextData);

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SidebarContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebarState() {
  const context = useContext(SidebarContext);

  if (context === undefined) {
    throw new Error("useSidebarState must be used within a SidebarProvider");
  }

  return context;
}
